module.exports = __webpack_public_path__ + "img/9_military.4e9bed5c.png";